import { PromiseUtils } from '../utils/PromiseUtils';

export function apiDelay() {
    return PromiseUtils.delay(400);
}

export function map<T, U>(x: T, func: (x: T) => U) {
    return func(x);
}
